import axios from 'axios';

const api = axios.create({ baseURL: 'https://kanguroo-crm-production.up.railway.app/api/v1' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  const listEndpoints = ['/customers', '/deals', '/tasks', '/users'];
  if (listEndpoints.includes(config.url)) {
    config.url = config.url + '/';
  }
  return config;
});

export default api;
